import { render, staticRenderFns } from "./AjaxForm.vue?vue&type=template&id=76e51428&"
import script from "./AjaxForm.vue?vue&type=script&lang=ts&"
export * from "./AjaxForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "AjaxForm.vue"
export default component.exports